<template>
  <div class="row">
    <div class="form-group col-md-12">
      <div class="card">
        <div class="card-header">
          <span>{{ $t('member.form.action.title') }}</span>
          
          <div class="float-right" >
            <a href="#action" name="action" @click="addAction"  v-if="compMode != CRUDMODE.READ">
              <span class="fa fa-plus fa-lg"></span>
            </a>
            &nbsp;
            <a href="#section" name="section" v-on:click="expandOrCollapse">
              <span class="fa fa-expand fa-lg" v-if="!localVisible" ></span>
              <span class="fa fa-compress fa-lg" v-if="localVisible"></span>
            </a>
          </div>
        </div>
        <div class="card-body" v-if="localVisible">
          <div class="row">

            <table id="dataTableAction" width="100%" cellspacing="0" 
                class="table table-bordered table-striped dataTable" >
             <thead>
                <tr>
                  <th width="300">{{ $t('member.form.action.type') }}</th>
                  <th width="150">{{ $t('member.form.action.timespan') }}</th>
                  <th>{{ $t('member.form.action.comment') }}</th>
                  <th width="50" v-if="compMode != CRUDMODE.READ"></th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                  <th>{{ $t('member.form.action.type') }}</th>
                  <th>{{ $t('member.form.action.timespan') }}</th>
                  <th>{{ $t('member.form.action.comment') }}</th>
                  <th width="50" v-if="compMode != CRUDMODE.READ"></th>
                </tr>
              </tfoot>
              <tbody>
                <tr class="odd" v-if="actions.length == 0">
                    <td valign="top" colspan="4" class="dataTables_empty">Aucune donnée disponible dans le tableau</td>
                </tr>

                <tr v-for="(item, index) in actions" v-bind:data-id="item.id" :key="item.id">
                  
                  <td>
                    <select v-model="item.type" :data-vv-name="'type' + index" @change="f=> memberActionChanged(item.type)"
                        v-validate="'required'" class="form-control" id="typeInput" :placeholder="$t('member.form.action.type')">
                        <option v-for="s in actionTypes" :value="s.item1" :key="s.item1">{{s.item2}}</option>
                    </select>
                    <span class="text-danger" v-if="errors.has('reason'+ index)">{{ $t('validations.required') }}</span>
                  </td>
                  <td>
                    <moment-date-picker v-model="item.timestamp" :required="true"></moment-date-picker>
                  </td>
                  <td>
                      <input v-model.trim="item.comment"  name="comment" 
                        type="text" class="form-control" id="comment" :placeholder="$t('member.form.action.comment')" />
                  </td>
                  <td align="center" v-if="compMode != CRUDMODE.READ">
                    <a  class="text-danger" v-bind:title="$t('form.delete_button')" href="#entrepreneur" v-on:click="removeAction(index)">
                        <span class="fa fa-lg fa-trash"></span>
                    </a><!-- v-if="item.id == undefined" -->
                    <!--a v-if="item.id != undefined" class="text-muted" v-bind:title="$t('form.delete_button')" >
                        <span class="fa fa-lg fa-trash"></span>
                    </a-->
                  </td> 
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {MemberServiceClient, MemberActionDto} from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import CrudMixin from '../../shared/Mixin/CrudMixin'
  import MomentDatePicker from '../../shared/components/MomentDatePicker'

  export default {
    name: 'CreateMemberAction',
    props: {
      actions: {},
      type: {},
    },
    data() {
      return {
        actionTypes: [],
        localVisible: true,
      }
    },
    watch: {
      type: {
        handler: function(newVal) {
          this.localVisible = this.type == 2
        },
        immediate: true,
      },
    },
    mixins: [CrudMixin],
    mounted: function() {
      let self = this
      setTimeout(function() {
        self.fetchData()
        self.setMode()
      }, 1000)
    },
    methods: {
      memberActionChanged: function(type) {
        this.$emit('memberTypeChanged', type)
      },
      expandOrCollapse: function() {
        this.localVisible = !this.localVisible
      },
      fetchData: function() {
        let memberService = ServiceFactory.create(MemberServiceClient)
        let getActionTypes = memberService.getActionTypes()
        let self = this
        getActionTypes
          .then(res => {
            self.actionTypes = res
          })
          .catch(err => {
            err
          })
      },
      addAction: function() {
        let dto = new MemberActionDto()
        dto.init({})
        this.actions.push(dto)
      },
      removeAction: function(index) {
        this.actions.splice(index, 1)
      },
    },
    components: {
      'moment-date-picker': MomentDatePicker,
    },
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
</style>



// WEBPACK FOOTER //
// src/components/members/CreateMemberAction.vue